import React from 'react';

const BuildersDropdown = (
  {
    builders = [],
    userType,
    className,
    value,
    disabled = false,
    onChange = () => {}
  },
  props
) => {
  if (!builders.length) return '';

  return (
    <select
      className={`form__input form__input--lg ${className ? className : ''}`}
      value={value}
      disabled={disabled}
      onChange={onChange}
      {...props}
    >
      <option value="0">{`-- ${userType} --`}</option>
      {builders.map(
        ({ ID, last_name, first_name, user_email, company }, index) => (
          <option key={index} value={ID}>
            {last_name && last_name}
            {first_name && `, ${first_name}`} ({user_email})
            {company && ` - ${company}`}
          </option>
        )
      )}
    </select>
  );
};

export default BuildersDropdown;
